<template>
    <div class="d-flex flex-column vh-100">
        <header class="container header-checkout my-5">
            <div class="row mb-2">
                <div class="col-12 col-xl-3 my-xl-auto text-center text-xl-left">
                    <img v-if="store.logoUrl" :src="store.logoUrl" class="animated fadeInDown faster rounded" style="max-width:100%; max-height:100px;"/>
                    <h3 v-else class="mb-0 animated fadeInDown faster">{{ store.name }}</h3>
                </div>
                <div class="col-12 col-md-12 col-lg-10 col-xl-8 ml-xl-auto mx-xl-0 mx-auto my-auto px-0 pt-5 pt-xl-0 d-none d-md-block">
                    <div class="row justify-content-end">
                        <div v-for="item in steps" class="col-4 header-checkout-step animated fadeInDown faster">
                            <Step :active="step === item.id" :icon="item.icon" :message="item.message" :title="item.title"/>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main id="app" class="container main-checkout pb-3 pb-md-5" role="main">
            <div v-if="items === null" class="text-center">
                <i class="fal fa-spinner fa-spin fa-2x"></i>
            </div>
            <div v-else-if="items.length > 0">
                <SetupResponse v-if="setupResponse"/>
                <component v-else :is="steps.find((component) => component.id === step).component"/>
            </div>
            <div v-else class="card text-center mb-3 mb-md-5 animated fadeInUp faster">
                <div class="card-body py-md-5 py-3">
                    <div class="row">
                        <div class="col-12 col-lg-10 mx-md-auto">
                            <i class="border border-primary border-3 rounded-circle p-3 fal fa-shopping-basket text-primary fa-3x mx-auto mb-4"></i>
                            <h1 class="font-weight-normal h4 mt-4">{{ $t("basket.empty") }}</h1>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-center">
                    <a :href="store.basketUrl" class="btn btn-primary"><i class="fas fa-angle-left mr-3"></i>{{ $t("details.back_to_basket") }}</a>
                </div>
            </div>
        </main>

        <FloatingFooter/>
    </div>
</template>

<script>
    import BasketList from "./BasketList";
    import Coupon from "./Coupon";
    import Details from "./Details";
    import PaymentMethods from "./PaymentMethods";
    import { mapActions, mapState } from "vuex";
    import SetupResponse from "./SetupResponse/SetupResponse";
    import CreatorCode from "./CreatorCode";
    import FloatingFooter from "./FloatingFooter.vue";
    import Step from "./Step";

    export default {
        name: "App",
        mounted() {
            this.fetchBasket();
        },
        computed: {
            ...mapState({
                locale: state => state.locale,
                step: state => state.app.step,
                error: state => state.app.error,
                items: state => state.basket.items,
                store: state => state.app.store,
                isPaymentMethodUpdate: state => state.basket.isPaymentMethodUpdate,
                setupResponse: state => state.payment.setupResponse
            }),
            steps() {
                if (this.isPaymentMethodUpdate) {
                    return [
                        {
                            id: 1,
                            title: this.$t("steps.step_one"),
                            message: this.$t("steps.payment_method"),
                            icon: 'fal fa-credit-card',
                            component: PaymentMethods
                        },
                        {
                            id: 2,
                            title: this.$t("steps.step_two"),
                            message: this.$t("steps.confirmation"),
                            icon: 'fal fa-check'
                        }
                    ];
                } else {
                    return [
                        {
                            id: 1,
                            title: this.$t("steps.step_one"),
                            message: this.$t("steps.your_details"),
                            icon: 'fal fa-user',
                            component: Details
                        },
                        {
                            id: 2,
                            title: this.$t("steps.step_two"),
                            message: this.$t("steps.payment_method"),
                            icon: 'fal fa-credit-card',
                            component: PaymentMethods
                        },
                        {
                            id: 3,
                            title: this.$t("steps.step_three"),
                            message: this.$t("steps.order_confirmed"),
                            icon: 'fal fa-check'
                        }
                    ];
                }
            }
        },
        methods: {
            ...mapActions('locale', ['changeLocale']),
            ...mapActions(['fetchBasket'])
        },
        components: {
            FloatingFooter,
            SetupResponse,
            Details,
            Coupon,
            CreatorCode,
            BasketList,
            PaymentMethods,
            Step
        }
    }
</script>

<style scoped>

</style>
